<script>
import options from './FundRaisingCounter.options'
import './rolling-number.js'

export default {
  name: 'FundRaisingCounter',
  ...options
}
</script>

<template>
  <article class="kb-fund-raising-counter">
    <section class="kb-fund-raising-counter__top">
      <div class="kb-fund-raising-counter__container">
        <h1 class="kb-fund-raising-counter__hashtag">{{ title }}</h1>

        <div class="kb-fund-raising-counter__roller-groups">
          <div v-for="(group, idx) in digitGroups" :key="idx" class="kb-fund-raising-counter__roller-group">
            <layflags-rolling-number :value="group" class="kb-fund-raising-counter__roller" />
            <span v-if="idx < digitGroups.length - 1" class="kb-fund-raising-counter__separator">.</span>
          </div>
          <span class="kb-fund-raising-counter__roller-currency">‎ kr</span>
        </div>

        <p class="kb-fund-raising-counter__label">Indsamlet</p>
        <p class="kb-fund-raising-counter__description" v-html="description"></p>
        <a class="kb-fund-raising-counter__button" :href="linkUrl" :title="linkTitle" :target="linkTarget">
          {{ linkText }}
        </a>
      </div>
    </section>

    <div class="kb-fund-raising-counter__curve">
      <section class="kb-fund-raising-counter__bottom">
        <div class="kb-fund-raising-counter__container--ambassadors kb-fund-raising-counter__ambassadors">
          <div class="kb-fund-raising-counter__ambassador kb-fund-raising-counter__ambassador--high-raised">
            <img :src="nonCenteredImages[0][imageKey]" class="kb-fund-raising-counter__image" />
          </div>
          <div class="kb-fund-raising-counter__ambassador kb-fund-raising-counter__ambassador--raised">
            <img :src="nonCenteredImages[1][imageKey]" class="kb-fund-raising-counter__image" />
          </div>
          <div class="kb-fund-raising-counter__ambassador kb-fund-raising-counter__ambassador--center">
            <img :src="centerImage[imageKey]" class="kb-fund-raising-counter__image" />
          </div>
          <div class="kb-fund-raising-counter__ambassador kb-fund-raising-counter__ambassador--raised">
            <img :src="nonCenteredImages[2][imageKey]" class="kb-fund-raising-counter__image" />
          </div>
          <div class="kb-fund-raising-counter__ambassador kb-fund-raising-counter__ambassador--high-raised">
            <img :src="nonCenteredImages[3][imageKey]" class="kb-fund-raising-counter__image" />
          </div>
        </div>
      </section>
    </div>
  </article>
</template>